export default __webpack_public_path__ + "static/media/T850_RoHS.9d1c66b1.pdf";